export const SeatCoversFallbackSvg = (
	<svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_3242_95624)">
			<mask
				id="mask0_3242_95624"
				style={{ maskType: 'luminance' }}
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="68"
				height="68">
				<path
					d="M34 67.7958C52.6646 67.7958 67.7953 52.6651 67.7953 34.0005C67.7953 15.3358 52.6646 0.205078 34 0.205078C15.3353 0.205078 0.20459 15.3358 0.20459 34.0005C0.20459 52.6651 15.3353 67.7958 34 67.7958Z"
					fill="white"
				/>
			</mask>
			<g mask="url(#mask0_3242_95624)">
				<path
					d="M5.63118 16.7716H29.0481C29.0481 16.7716 46.4819 15.7567 53.5373 29.1062C61.051 43.3152 56.8276 49.3474 56.8276 49.3474L59.2012 56.9266V70.0797H-2.72559V16.7716H5.63118Z"
					fill="black"
					fillOpacity="0.05"
				/>
				<path
					d="M-0.540265 15.4867H29.3264C31.0125 15.4867 32.5348 14.4636 33.1405 12.8839C33.9017 10.895 34.4665 7.39182 33.9918 1.22042C32.7886 -14.5355 31.0698 -1.30871 31.0698 -1.30871H-3.47864L-0.556635 14.9628L-0.540265 15.4867Z"
					fill="black"
					fillOpacity="0.05"
				/>
				<path d="M25 15.5H22V16.9L25 16.9V15.5Z" fill="black" fillOpacity="0.05" />
				<path
					d="M67.5453 34.0005C67.5453 52.5271 52.5266 67.5458 34 67.5458C15.4734 67.5458 0.45459 52.5271 0.45459 34.0005C0.45459 15.4739 15.4734 0.455078 34 0.455078C52.5266 0.455078 67.5453 15.4739 67.5453 34.0005Z"
					stroke="#B3B3B3"
					strokeWidth="0.5"
				/>
				<path
					d="M4.14968 18.1468H4.82474M5.37741 18.1468H30.9388C35.2604 18.2777 39.3938 20.0866 42.324 23.2623C47.0385 28.3615 52.2031 39.4356 54.3639 60.1025M54.4049 60.5035C54.4212 60.6427 54.4294 60.7736 54.4458 60.9128M3.72409 18.9652H4.40853M4.95999 18.9652H30.3249C34.6466 19.0962 38.7799 20.8969 41.7101 24.0726C46.4246 29.1718 51.0982 40.2459 53.2426 60.9046M53.2835 61.322C53.2999 61.4611 53.3081 61.5921 53.3245 61.7312M53.4227 52.466C54.4704 51.2792 55.5671 50.2479 56.8276 49.3393M45.9499 65.6191C45.9499 65.6191 48.1189 59.1121 52.3423 53.751M6.26958 53.3172H21.8372C24.039 53.3172 26.2243 53.7346 28.2378 54.6186C31.6918 56.1328 37.1348 59.374 43.9282 66.3066M34.8839 58.4737L30.325 67.5998M29.3346 15.4867C29.3346 15.4867 33.7708 15.9532 34 1.22861M25 15.5009V16.7665L22 16.7821V15.5009H25ZM29.0481 16.7717C29.0481 16.7717 46.4819 15.7568 53.5373 29.1063C61.051 43.3153 56.8276 49.3475 56.8276 49.3475L59.2012 56.9267V70.0798H-2.72559V16.7717H29.0481ZM-0.540238 15.4867H29.3264C31.0125 15.4867 32.5349 14.4636 33.1406 12.8839C33.9017 10.895 34.4665 7.39182 33.9918 1.22042C32.7886 -14.5355 31.5199 -1.30871 31.5199 -1.30871H-3.02844L-0.556608 14.9628L-0.540238 15.4867Z"
					stroke="#B3B3B3"
					strokeWidth="0.409244"
					strokeMiterlimit="10"
					strokeLinecap="round"
				/>
			</g>
		</g>
		<defs>
			<clipPath id="clip0_3242_95624">
				<rect width="68" height="68" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
